export default __webpack_public_path__ + "static/media/g6.60d680c9.jpg";